<template>
  <div class="index_user">
    <h3>访问的页面不存在</h3>
    <el-button type="danger" size="mini" @click="toIndex">点击返回首页</el-button>
  </div>
</template>

<script>
  export default {
    name: "notfound",
    data() {
      return {
        isMp: this.$browserType
      }
    },
    methods: {
      toIndex(){
        this.$router.push('/');
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/notfound.vue